import { Icon, Label } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { EventUserParticipationStatus } from "../../shared/types";

interface Props {
	status: EventUserParticipationStatus;
}

const StyledIcon = styled(Icon)`
	width: 1rem;
	height: 1rem;
`;

export const EventUserParticipationStatusLabel: FC<Props> = ({ status }) => {
	const { t } = useTranslation();

	switch (status) {
		case "participating":
			return (
				<Label color="success">
					<StyledIcon $icon="check" /> {t("I'm participating")}
				</Label>
			);
		case "request":
			return (
				<Label color="warning">
					<StyledIcon $icon="hourglass" /> {t("Participation requested")}
				</Label>
			);
		case "none":
			return null;
	}
};
